import {Injectable} from '@angular/core';
import {DomainDataService} from './domain-data.service';
import {RadioModel} from '../../../personal-data/model/radio.model';
import {DomainDataType} from "./model/domain-data-type";
import {DomainOrigin} from "./model/domain-origin";

@Injectable({
  providedIn: 'root'
})
export class DomainDataMockService implements DomainDataService{

  readonly domainsAll = [];
  private counter = 0;

  constructor() {
    this.domainsAll.push(this.getDocumentTypeItems());
    this.domainsAll.push(this.getDocumentNationality());
    this.domainsAll.push(this.getDomainState());
    this.domainsAll.push(this.getDomainCountry());
    this.domainsAll.push(this.getGenderType());
    this.domainsAll.push(this.getOriginIncomeItems());
    this.domainsAll.push(this.getMaritalType());
    this.domainsAll.push(this.getGenericItems());
    this.domainsAll.push(this.getDocumentIssuingItems());
    this.domainsAll.push(this.getEmptyItems());
    this.domainsAll.push(this.getProfessionType());
    this.domainsAll.push(this.getCities());
    this.domainsAll.push(this.getDomainCountryNif());
  }
  getDomainRoot(domainType: DomainDataType, parameter?: any): Promise<RadioModel[]> {
    throw new Error('Method not implemented.');
  }

  public async getDomains(domainDataType: DomainDataType, parameter?: any): Promise<RadioModel[]> {
    const domains = this.domainsAll.find(r => r.code === domainDataType)?.dominios;

    if (domains) {
    //  return this.simulateError(domains);
      return Promise.resolve(domains);
    } else {
      return Promise.resolve(this.getGenericItems().dominios);
    }
  }
  
  

  protected getEmptyItems() {
    return {
      code: DomainDataType.Empty,
      dominios: []
    };
  }

  protected getGenericItems(){
    return {code: DomainDataType.Generic,
      dominios: [
        new RadioModel('2', 'AFEGA', 'AFEGA'),
        new RadioModel('3', 'ALBANESA', 'ALBANESA'),
        new RadioModel('4', 'BARAINITA', 'BARAINITA'),
        new RadioModel('5', 'BARAMENHA', 'BARAMENHA'),
        new RadioModel('6', 'BELGA', 'BELGA'),
        new RadioModel('7', 'BELIZENHA', 'BELIZENHA'),
        new RadioModel('8', 'BENGALENSE', 'BENGALENSE'),
        new RadioModel('9', 'BIELO-RUSSA', 'BIELO-RUSSA'),
        new RadioModel('10', 'BOLIVIANA', 'BOLIVIANA'),
        new RadioModel('1', 'Brasileiro(a)', 'Brasileiro(a)'),
        new RadioModel('11', 'BRITANICA (BM)', 'BRITANICA (BM)'),
        new RadioModel('12', 'CABO-VERDINA', 'CABO-VERDINA'),
        new RadioModel('13', 'CAIMENSE', 'CAIMENSE'),
        new RadioModel('14', 'CAMBOJANA', 'CAMBOJANA'),
      ]
    };
  }

  protected getDocumentIssuingItems(){
    return {code: DomainDataType.DocumentIssuing,
      dominios: [
        new RadioModel('1', 'SSP', 'SSP'),
        new RadioModel('2', 'SSP2', 'SSP2'),
        new RadioModel('3', 'SSP3', 'SSP3'),
        new RadioModel('4', 'SSP3', 'SSP3'),
        new RadioModel('5', 'SSP3', 'SSP3'),
        new RadioModel('6', 'SSP3', 'SSP3'),
        new RadioModel('7', 'SSP3', 'SSP3'),
        new RadioModel('8', 'SSP3', 'SSP3'),
        new RadioModel('9', 'SSP3', 'SSP3'),
        new RadioModel('10', 'SSP3', 'SSP3'),
        new RadioModel('11', 'SSP3', 'SSP3'),
        new RadioModel('12', 'SSP3', 'SSP3'),
        new RadioModel('13', 'SSP3', 'SSP3'),
        new RadioModel('14', 'SSP3', 'SSP3'),
        new RadioModel('15', 'SSP3', 'SSP3'),
        new RadioModel('16', 'SSP3', 'SSP3'),
        new RadioModel('17', 'SSP3', 'SSP3'),
        new RadioModel('18', 'SSP3', 'SSP3'),
        new RadioModel('19', 'SSP3', 'SSP3'),
        new RadioModel('20', 'SSP3', 'SSP3'),
      ]
    };
  }

  protected getDocumentTypeItems(){
    return {code: DomainDataType.DocumentType,
      dominios: [
        new RadioModel('551', 'RG', 'RG'),
        new RadioModel('552', 'RNE', 'RNE'),
        new RadioModel('558', 'CNH', 'CNH')
      ]
    };
  }

  protected getDocumentNationality(){
    return {code: DomainDataType.Nationality,
      dominios: [
        new RadioModel('551', 'TURCA', 'TURCA'),
        new RadioModel('552', 'ALEMA', 'ALEMA'),
        new RadioModel('558', 'JAMAICANA', 'JAMAICANA'),
        new RadioModel('560', 'JAPONESA', 'JAPONESA'),
        new RadioModel('561', 'ESPANHOLA', 'ESPANHOLA'),
        new RadioModel('562', 'ITALIANA', 'ITALIANA'),
        new RadioModel('563', 'URUGUAIA', 'URUGUAIA'),
        new RadioModel('648', 'BRASILEIRA', 'BRASILEIRA'),
        new RadioModel('565', 'HAITIANA', 'HAITIANA'),
        new RadioModel('566', 'MEXICANA', 'MEXICANA'),
      ]
    };
  }

  protected getDomainState(){
    return {code: DomainDataType.State,
      dominios: [
        new RadioModel('AC', 'ACRE', 'Acre'),
        new RadioModel('AL', 'ALAGOAS', 'Alagoas'),
        new RadioModel('AP', 'AMAPA', 'Amapá'),
        new RadioModel('AM', 'AMAZONAS', 'Amazonas'),
        new RadioModel('BA', 'BAHIA', 'Bahia'),
        new RadioModel('CE', 'CEARA', 'Ceará'),
        new RadioModel('DF', 'DISTRITO FEDERAL', 'Distrito Federal'),
        new RadioModel('ES', 'ESPIRITO SANTO', 'Espírito Santo'),
        new RadioModel('GO', 'GOIAS', 'Goiás'),
        new RadioModel('MA', 'MARANHAO', 'Maranhão'),
        new RadioModel('MT', 'MATO GROSSO', 'Mato Grosso'),
        new RadioModel('MS', 'MATO GROSSO DO SUL', 'Mato Grosso do sul'),
        new RadioModel('MG', 'MINAS GERAIS', 'Minas Gerais'),
        new RadioModel('PA', 'PARA', 'Pará'),
        new RadioModel('PB', 'PARAIBA', 'Paraíba'),
        new RadioModel('PR', 'PARANA', 'Paraná'),
        new RadioModel('PE', 'PERNAMBUCO', 'Pernambuco'),
        new RadioModel('PI', 'PIAUI', 'Piauí'),
        new RadioModel('RJ', 'RIO DE JANEIRO', 'Rio de Janeiro'),
        new RadioModel('RN', 'RIO GRANDE DO NORTE', 'Rio Grande do Norte'),
        new RadioModel('RS', 'RIO GRANDE DO SUL', 'Rio Grande do Sul'),
        new RadioModel('RO', 'RONDONIA', 'Rondônia'),
        new RadioModel('RR', 'RORAIMA', 'Roraima'),
        new RadioModel('SC', 'SANTA CATARINA', 'Santa Catarina'),
        new RadioModel('SP', 'SAO PAULO', 'São Paulo'),
        new RadioModel('SE', 'SERGIPE', 'Sergipe'),
        new RadioModel('TO', 'TOCANTINS', 'Tocantins'),
      ]
    };
  }

  protected getDomainCountry(){
    return {code: DomainDataType.Country,
      dominios: [
        new RadioModel('648', 'BRASIL', 'BRASIL'),
        new RadioModel('552', 'AFEGANISTÃO', 'AFEGANISTÃO'),
        new RadioModel('558', 'ÁFRICA DO SUL', 'ÁFRICA DO SUL'),
        new RadioModel('560', 'ALBÂNIA', 'ALBÂNIA'),
        new RadioModel('561', 'ALEMANHA', 'ALEMANHA'),
        new RadioModel('562', 'ARGENTINA', 'ARGENTINA'),
        new RadioModel('563', 'BOSNIA', 'BOSNIA'),
        new RadioModel('551', 'CHILE', 'CHILE'),
        new RadioModel('565', 'DINAMARCA', 'DINAMARCA'),
        new RadioModel('566', 'FRANÇA', 'FRANÇA'),
      ]
    };
  }

  protected getDomainCountryNif(){
    const onlyCharacters = [
      {
        validacoes_nif: {
          minimo_caracteres: 10,
          preenchimento_obrigatorio: true,
          maximo_caracteres: 10,
          tamanhos_permitidos: "",
          formato: "SOMENTE_LETRAS",
          caracteres_especiais_nao_permitidos: ""
        }
      }
    ]; 
    const onlyNumbers = [
      {
        validacoes_nif: {
          minimo_caracteres: 0,
          preenchimento_obrigatorio: true,
          maximo_caracteres: 0,
          tamanhos_permitidos: "9;11;13",
          formato: "SOMENTE_NUMEROS",
          caracteres_especiais_nao_permitidos: ""
        }
      }
    ];
    const alphanumerical = [
      {
        validacoes_nif: {
          minimo_caracteres: 9,
          preenchimento_obrigatorio: true,
          maximo_caracteres: 9,
          tamanhos_permitidos: "",
          formato: "ALFANUMERICO",
          caracteres_especiais_nao_permitidos: ""
        }
      }
    ]; 
    const withSpecialCharacters = [
      {
        validacoes_nif: {
          minimo_caracteres: 11,
          preenchimento_obrigatorio: true,
          maximo_caracteres: 11,
          tamanhos_permitidos: "",
          formato: "COM_CARACTERES_ESPECIAIS",
          caracteres_especiais_nao_permitidos: "!@#$%¨&*():{}[]|/\\?<>='\"´`^~,_;.áàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ"
        }
      }
    ];
    const nullValue = [];
    return {code: DomainDataType.CountryNif,
      dominios: [
        new RadioModel('BR', 'BRASIL', 'BRASIL', nullValue),
        new RadioModel('AW', 'ARUBA', 'ARUBA', onlyCharacters),
        new RadioModel('AD', 'ANDORRA', 'ANDORRA', onlyNumbers),
        new RadioModel('AR', 'ARGENTINA', 'ARGENTINA', onlyNumbers),
        new RadioModel('BE', 'BELGICA', 'BELGICA', alphanumerical),
        new RadioModel('UY', 'URUGUAI', 'URUGUAI', alphanumerical),
        new RadioModel('CL', 'CHILE', 'CHILE', withSpecialCharacters),
        new RadioModel('DK', 'DINAMARCA', 'DINAMARCA', withSpecialCharacters),
        new RadioModel('FI', 'FINLANDIA', 'FINLANDIA', withSpecialCharacters),
        new RadioModel('CF', 'REPUBLICA CENTRO-AFRICANA', 'REPUBLICA CENTRO-AFRICANA', alphanumerical),
      ]
    };
  }

  protected getGenderType(){
    return {code: DomainDataType.Gender,
      dominios: [
        new RadioModel('1191', 'FEMININO', 'FEMININO'),
        new RadioModel('1192', 'MASCULINO', 'MASCULINO'),
      ]
    };
  }

  protected getOriginIncomeItems(){
    return {code: DomainDataType.OriginIncome,
      dominios: [
        new RadioModel('11839', 'APOSENTADO/ PENSIONISTA', 'APOSENTADO/ PENSIONISTA', {patrimonyRequired: true, incomeRequired: true}),
        new RadioModel('11831', 'AUTONOMO', 'AUTONOMO', {patrimonyRequired: true, incomeRequired: true}),
        new RadioModel('11843', 'BENEFICIARIO INSS', 'BENEFICIARIO INSS', {patrimonyRequired: true, incomeRequired: true}),
        new RadioModel('11838', 'BENEFICIARIO PENSAO ALIMENTICIA', 'BENEFICIARIO PENSAO ALIMENTICIA', {patrimonyRequired: true, incomeRequired: true}),
        new RadioModel('11841', 'DONA DE CASA', 'DONA DE CASA', {patrimonyRequired: true, incomeRequired: false}),
        new RadioModel('11829', 'EMPREGADO EMPRESA PRIVADA', 'EMPREGADO EMPRESA PRIVADA', {patrimonyRequired: true, incomeRequired: true}),
        new RadioModel('11834', 'ESTUDANTE/ BOLSISTA', 'ESTUDANTE/ BOLSISTA', {patrimonyRequired: true, incomeRequired: false}),
        new RadioModel('11837', 'INVESTIDOR RECEBENDO RENDIMENTOS', 'INVESTIDOR RECEBENDO RENDIMENTOS', {patrimonyRequired: true, incomeRequired: true}),
        new RadioModel('11846', 'MICRO EMPRESARIO', 'MICRO EMPRESARIO', {patrimonyRequired: true, incomeRequired: true}),
        new RadioModel('12229', 'MICROEMPREENDEDOR INDIVIDUAL (MEI)', 'MICROEMPREENDEDOR INDIVIDUAL (MEI)', {patrimonyRequired: true, incomeRequired: true}),
        new RadioModel('11845', 'MILITAR', 'MILITAR', {patrimonyRequired: true, incomeRequired: true}),
        new RadioModel('11842', 'NAO ESPECIFICADA ANTERIORMENTE', 'NAO ESPECIFICADA ANTERIORMENTE', {patrimonyRequired: true, incomeRequired: true}),
        new RadioModel('12230', 'DESEMPREGADO / NAO EXERCE ATIVIDADE REMUNERADA', 'DESEMPREGADO / NAO EXERCE ATIVIDADE REMUNERADA', {patrimonyRequired: true, incomeRequired: false}),
        new RadioModel('11840', 'PROPRIETARIO DE IMOVEL RECEBENDO ALUGUEL', 'PROPRIETARIO DE IMOVEL RECEBENDO ALUGUEL', {patrimonyRequired: true, incomeRequired: true}),
        new RadioModel('11833', 'PROPRIETARIO RURAL', 'PROPRIETARIO RURAL', {patrimonyRequired: true, incomeRequired: true}),
        new RadioModel('11830', 'PROPRIETARIO LIBERAL', 'PROPRIETARIO LIBERAL', {patrimonyRequired: true, incomeRequired: true}),
        new RadioModel('11835', 'SERVIDOR PUBLICO ESTATUTARIO', 'SERVIDOR PUBLICO ESTATUTARIO', {patrimonyRequired: true, incomeRequired: true}),
        new RadioModel('11836', 'SERVIDOR PUBLICO/ ECONOMIA MISTA (CLT)', 'SERVIDOR PUBLICO/ ECONOMIA MISTA (CLT)', {patrimonyRequired: true, incomeRequired: true}),
        new RadioModel('11832', 'SOCIO/ PROPRIETARIO EMPRESA', 'SOCIO/ PROPRIETARIO EMPRESA', {patrimonyRequired: true, incomeRequired: true})
      ]
    };
  }

  protected getMaritalType(){
    return {code: DomainDataType.MaritalStatus,
      dominios: [
        new RadioModel('608', 'CASADO', 'CASADO'),
        new RadioModel('611', 'DIVORCIADO', 'DIVORCIADO'),
        new RadioModel('616', 'SEPARADO', 'SEPARADO'),
        new RadioModel('617', 'SOLTEIRO', 'SOLTEIRO'),
        new RadioModel('612', 'UNIAO ESTAVEL', 'UNIAO ESTAVEL'),
        new RadioModel('618', 'VIUVO', 'VIUVO'),
      ]
    };
  }

  protected getCities(){
    return {code: DomainDataType.City,
      dominios: [
        new RadioModel('3500105', 'ADAMANTINA', 'ADAMANTINA'),
        new RadioModel('3500204', 'ADOLFO', 'ADOLFO'),
        new RadioModel('3503208', 'ARARAQUARA', 'ARARAQUARA'),
        new RadioModel('3513009', 'COTIA', 'COTIA'),
        new RadioModel('3550308', 'SAO PAULO', 'SAO PAULO'),
        new RadioModel('3556453', 'VARGEM GRANDE PAULISTA', 'VARGEM GRANDE PAULISTA'),
      ]
    };
  }


  protected getProfessionType(){
    return {code: DomainDataType.Profession,
      dominios: [
        new RadioModel('959', 'ACOUGUEIRO', 'ACOUGUEIRO'),
        new RadioModel('961', 'ADVOGADO', 'ADVOGADO'),
        new RadioModel('962', 'AEROVIARIOS', 'AEROVIARIOS'),
        new RadioModel('963', 'AFIADOR', 'AFIADOR'),
        new RadioModel('964', 'AGENCIADOR DE PROPAGANDA', 'AGENCIADOR DE PROPAGANDA'),
        new RadioModel('965', 'AGENCIADOR DE SERVICOS', 'AGENCIADOR DE SERVICOS'),
      ]
    };
  }

  public simulateError(domains: RadioModel[]) {
    this.counter = this.counter + 1;

    if (this.counter <= 1) {
      return Promise.resolve([]);
    } else {
      this.counter = 0;
      return Promise.resolve(domains);
    }
  };

  getOrigin(): DomainOrigin {
    return DomainOrigin.Mock;
  }
}
